import type { ChartDataSymbol } from '@/components/Chart/types/chartData';
import type { TemplateChartSeries } from '@/types/charts';

/**
 * Checks if a template series is valid by verifying its transaction date
 * is not in the list of invalid symbols
 * @param templateSeries - Template chart series to validate
 * @param invalidSymbols - Array of invalid chart data symbols
 * @returns true if the template is valid, false otherwise
 */
export const isTemplateValid = (
  templateSeries: TemplateChartSeries,
  invalidSymbols: ChartDataSymbol[]
): boolean => {
  const invalidTransactionDates = invalidSymbols.map(symbol => symbol.transactionDate);
  return !invalidTransactionDates.includes(templateSeries.symbol.transactionDate);
};
